// src/pages/Community/StoryCharacters/CharacterDetailPanel.jsx
import React, { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase";
import CharacterDetailContent from "./CharacterDetailContent";
import { normalizeCharacterData } from "./CharacterDetail";
export default function CharacterDetailPanel({ characterId, user }) {
    const [c, setC] = useState(null);

    useEffect(() => {
        if (!characterId) return;

        return onSnapshot(doc(db, "characters", characterId), (snap) => {
            if (!snap.exists()) {
                setC(null);
                return;
            }

            const normalized = normalizeCharacterData(snap.data());
            setC({ id: snap.id, ...normalized });
        });
    }, [characterId]);

    // ✅ Same guards as MissionDetailPanel
    if (!characterId) {
        return <div style={{ padding: 16 }}>Select a character</div>;
    }

    if (!c) {
        return <div style={{ padding: 16 }}>Loading…</div>;
    }

    return (
        <div className="msn-panel-body">

            {/* PANEL HEADER (same pattern as missions) */}
            <div className="msn-panel-header">
                <h1 className="char-detail-title">
                    {c.name}
                </h1>
            </div>

            {/* SCROLLABLE CONTENT */}
            <div className="msn-panel-scroll">
                <CharacterDetailContent
                    c={c}
                    showTitle
                    basePath={["characters", c.id]}
                    selectedReaction={null}
                    onSelectReaction={() => { }}
                    onOpenLightbox={() => { }}
                    showDiscussion={true}
                />
            </div>

        </div>
    );

}
